const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/rbac/audit-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { RbacAuditLogFilterParamSchema } from '@apps/main/features/admin/pages/rbac/audit-log-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/rbac/audit-log')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: RbacAuditLogFilterParamSchema
});